var _style, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#010024;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10,15.8c-3.2,0-5.8-2.6-5.8-5.8c0-2.3,1.3-4.3,3.3-5.3V2.9c-2.9,1-5,3.8-5,7.1c0,4.1,3.4,7.5,7.5,7.5 c3.2,0,6-2.1,7.1-5h-1.8C14.3,14.5,12.3,15.8,10,15.8L10,15.8z M19.2,10.8l-0.2,1c-0.9,4.2-4.6,7.3-9,7.3c-5.1,0-9.2-4.1-9.2-9.2 c0-4.4,3.1-8.1,7.3-9l1-0.2v5.1L8.6,6.1C7,6.7,5.8,8.2,5.8,10c0,2.3,1.9,4.2,4.2,4.2c1.8,0,3.3-1.1,3.9-2.8l0.2-0.6 C14.1,10.8,19.2,10.8,19.2,10.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,7.5c-0.8-2.1-2.4-3.8-4.6-4.6v1.8c1.2,0.6,2.2,1.6,2.8,2.8H17.1z M13.9,8.6c-0.4-1.2-1.4-2.1-2.5-2.5 l-0.6-0.2V0.8l1,0.2c3.6,0.7,6.4,3.6,7.1,7.1l0.2,1h-5L13.9,8.6z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon-dashboard.6fce3d5026ad771625cff400ea23c53a.svg";
export { ForwardRef as ReactComponent };